import React, {useEffect, useState} from "react";
import {
    Button,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Table,
    TableCell,
    TableRow
} from "@material-ui/core";
//import DateTimePicker from "react-datetime-picker/src/DateTimePicker";
import DateTimePicker from "react-datetime-picker";
import CgSelect from "../core/CgSelect";
import axios from "axios";
import dateHelper from "../core/dateHelper";
import {Label} from "@mui/icons-material";

export function CampaignDialog(props){
    const {onDock, goParameters} = props;
    const [open,setOpen] = useState(false);
    const [from,setFrom] = useState(null);
    const [campaign, setCampaign] = useState(null);
    const [onOk, setOnOk] = useState(() => () => alert("no onOk set"));
    //const [goParameters, setGoParameters] = useState([]);
    const show = (campaign, onOk) => {setOpen(true); setCampaign(campaign); setOnOk(() => onOk)};

    useEffect(() => {
        onDock(show);
    },[]); // eslint-disable-line react-hooks/exhaustive-deps

    return <Dialog open={open} onclose={() => setOpen(false)}

    >
        <DialogTitle>Campaign</DialogTitle>
        <DialogContent>
            <DialogContentText>

            </DialogContentText>
            <Table style={{height:'400px'}}>
                <TableRow>
                    <TableCell>For Client</TableCell>
                    <TableCell>
                        <Chip
                            label={(campaign || {}).clientTitle}/>

                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>For RSE</TableCell>
                    <TableCell>
                        <Chip
                            label={(campaign || {}).tag2}/>

                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>Start Date</TableCell>
                    <TableCell>
                        <DateTimePicker style={{width:'400px'}} locale='en-US'
                                    value={dateHelper.toDate((campaign || {}).start)}
                                    onChange={dt => {
                                        if(!(campaign || {}).start){
                                            dt = dateHelper.addHours(dt, 9.5 );
                                        }
                                        setCampaign({...campaign, start:dt, end:dateHelper.addDays(dt,3)});
                                    }}
                        />
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>Interval</TableCell>
                    <TableCell>
                        Emails would be sent evenly within
                        <CgSelect style={{ width: '50px', marginLeft:'20px' }} options={[1]}
                                  value={(campaign || {}).tag3}
                                  onChange={value => {
                                      setCampaign({...campaign, tag3:value});
                                  }} />
                        Hours
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>Due Date</TableCell>
                    <TableCell>
                        <DateTimePicker style={{width:'400px'}} locale='en-US'
                                    value={dateHelper.toDate((campaign || {}).end)}
                                    onChange={dt => {
                                        setCampaign({...campaign, end:dt});
                                    }}
                        />
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>Email Account</TableCell>
                    <TableCell>
                        <CgSelect style={{ width: '300px' }} isMulti={false}
                                  options={(goParameters || []).map(p => p.from)}
                                  value={from}
                                  onChange={value => {
                                      setFrom(value);
                                      setCampaign({...campaign, sendingProfile:null});
                                  }} />
                    </TableCell>

                </TableRow>
                <TableRow>
                    <TableCell>Email Tamplate</TableCell>
                    <TableCell>
                        <CgSelect style={{ width: '300px' }}
                                  options={(goParameters.find(p => p.from === from) || {}).profiles || []}
                                  value={(campaign || {}).sendingProfile}
                                  onChange={value => {
                                      setCampaign({...campaign, sendingProfile:value});
                                  }} />
                    </TableCell>
                </TableRow>

            </Table>
        </DialogContent>
        <DialogActions>
            <Button onClick={() => setOpen(false)}>Cancel</Button>
            <Button onClick={() => {
                if(!campaign){
                    alert('No Campaign');
                    return;
                }
                if(!campaign.start){
                    alert('No Start Date');
                    return;
                }
                if(!campaign.end){
                    alert('No Due Date');
                    return;
                }
                if(!campaign.sendingProfile){
                    alert('No Email Template');
                    return;
                }
                setOpen(false);
                onOk(campaign);
            }}>OK</Button>
        </DialogActions>
    </Dialog>
}